import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export function getManagersList(partnerId) {
    return http.get(API_PATHS.listManagers, { params: { partnerId } });
}
export function deleteManager(managerId) {
    return http.delete(API_PATHS.deleteManager, { params: { managerId } });
}
